import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UrlServidor } from "../util/url-servidor";
import { Observable } from "rxjs";
import { SaidaCaixa } from "../api/dto/saida-caixa";

@Injectable({
    providedIn: 'root'
})
export class SaidaCaixaService{

    constructor(private http: HttpClient) {}

    private url: string = UrlServidor.URL_BASE + 'saidas-caixa';

    listarPorEmpresaECaixa(empresaId?: number, dataCaixa?: Date): Observable<SaidaCaixa[]> {
        console.log(dataCaixa)
        return this.http.get<SaidaCaixa[]>(`${this.url}/empresa/${empresaId}/caixa/${dataCaixa}`);
    }

    salvar(saidaCaixa?: SaidaCaixa): Observable<SaidaCaixa> {
        return this.http.post<SaidaCaixa>(this.url, saidaCaixa);
    }

    excluir(saidaId?: number): Observable<void> {
        return this.http.delete<void>(`${this.url}/${saidaId}`);
    }
}